module.exports = __webpack_public_path__ + "static/media/gitam_college_logo.4563fa25.png";